<style>
  /*
   * Die Kapitelnummern stehen bereits im Text der &Uuml;berschriften.
   * Dadurch wird eine zus&auml;tzliche Nummerierung aus globalen CSS-Regeln verhindert.
   */
  .ktbl-help h2,
  .ktbl-help h3,
  .ktbl-help h4 {
    counter-increment: none !important;
  }

  .ktbl-help h2::before,
  .ktbl-help h3::before,
  .ktbl-help h4::before {
    content: none !important;
    display: none !important;
  }

  .ktbl-help [id] {
    scroll-margin-top: 6rem;
  }

  .ktbl-help-toc {
    margin: 1.5rem 0 2rem;
  }

  .ktbl-help-toc ul {
    margin: 0.35rem 0;
    padding-left: 1.5rem;
  }

  .ktbl-help-toc>ul {
    padding-left: 1.25rem;
  }

  .ktbl-help-toc li {
    margin: 0.3rem 0;
  }

  .ktbl-help-toc a {
    white-space: normal !important;
    overflow-wrap: anywhere;
  }

  /* Keine Aufz&auml;hlungszeichen im Inhaltsverzeichnis */
  .ktbl-help .ktbl-help-toc ul,
  .ktbl-help .ktbl-help-toc ol,
  .ktbl-help .ktbl-help-toc li {
    list-style: none !important;
  }

  .ktbl-help .ktbl-help-toc>ul {
    margin-left: 0 !important;
    padding-left: 0 !important;
  }

  .ktbl-help .ktbl-help-toc ul ul {
    margin-left: 0 !important;
    padding-left: 1.5rem !important;
  }

  .ktbl-help .ktbl-help-toc li::marker {
    content: "" !important;
    font-size: 0 !important;
  }

  .ktbl-help .ktbl-help-toc li::before {
    content: none !important;
    display: none !important;
  }
</style>


<div class="ktbl-spacer-top-bottom"></div>

<div class="ktbl-container">
  <article class="ktbl-help">
    <h1>Hilfe zur Anwendung von BauKost </h1>

    <h2 id="inhaltsverzeichnis">
      Inhaltsverzeichnis
    </h2>

    <nav aria-labelledby="inhaltsverzeichnis" class="ktbl-help-toc">
      <ul>
        <li>
          <a href="hilfe#1-gebaeudeklasse-und-kategorie-auswaehlen">
            1. Geb&auml;udeklasse und Kategorie ausw&auml;hlen
          </a>
          <ul>
            <li>
              <a href="hilfe#1-1-filter-verwenden">
                1.1 Filter verwenden
              </a>
            </li>
            <li>
              <a href="hilfe#1-2-vorschaubilder-nutzen">
                1.2 Vorschaubilder nutzen
              </a>
            </li>
            <li>
              <a href="hilfe#1-3-gebaeudekennung">
                1.3 Geb&auml;udekennung
              </a>
            </li>
            <li>
              <a href="hilfe#1-4-modelle-zum-vergleich-hinzufuegen">
                1.4 Modelle zum Vergleich hinzuf&uuml;gen
              </a>
            </li>
            <li>
              <a href="hilfe#1-5-schnellnavigation">
                1.5 Schnellnavigation
              </a>
            </li>
          </ul>
        </li>

        <li>
          <a href="hilfe#2-modelle-vergleichen">
            2. Modelle vergleichen
          </a>
          <ul>
            <li>
              <a href="hilfe#2-1-verfuegbare-informationen">
                2.1 Verf&uuml;gbare Informationen
              </a>
            </li>
            <li>
              <a href="hilfe#2-2-diagramme">
                2.2 Diagramme
              </a>
            </li>
            <li>
              <a href="hilfe#2-3-anzeige-einschraenken">
                2.3 Anzeige einschr&auml;nken
              </a>
            </li>
          </ul>
        </li>

        <li>
          <a href="hilfe#3-einstellungen-anpassen">
            3. Einstellungen anpassen
          </a>
          <ul>
            <li>
              <a href="hilfe#3-1-preisstand-aendern">
                3.1 Preisstand &auml;ndern
              </a>
            </li>
            <li>
              <a href="hilfe#3-2-preisfaktor-verwenden">
                3.2 Preisfaktor verwenden
              </a>
            </li>
            <li>
              <a href="hilfe#3-3-kostengruppen-auswaehlen">
                3.3 Kostengruppen ausw&auml;hlen
              </a>
            </li>
          </ul>
        </li>

        <li>
          <a href="hilfe#4-ergebnisse-exportieren">
            4. Ergebnisse exportieren
          </a>
        </li>
      </ul>
    </nav>





    <h2 id="1-gebaeudeklasse-und-kategorie-auswaehlen">
      1. Gebäudeklasse und Kategorie auswählen
    </h2>

    <p>
      Wählen Sie zuerst unter Gebäudeklasse zwischen <strong>„Ställe“</strong>
      und <strong>„Bauliche Anlagen“</strong> aus.
    </p>

    <p>
      Anschließend können Sie bei den Ställen eine Tierkategorie (z. B. Milchkühe)
      auswählen. Bei den Baulichen Anlagen wählen Sie eine der thematisch sortierten
      Anlagentypen aus.
    </p>

    <p>
      Daraufhin wird eine Liste der <strong>„Gefundene Gebäude“</strong> angezeigt.
    </p>

    <p>
      Die Zahl in Klammern zeigt jeweils an, wie viele Modelle verfügbar sind.
    </p>

    <h3 id="1-1-filter-verwenden">
      1.1 Filter verwenden
    </h3>

    <p>
      Über die aufklappbare Filterfunktion können Sie die Auswahl der gefundenen
      Gebäude weiter eingrenzen, beispielsweise nach:
    </p>

    <ul>
      <li>Anzahl Tierplätze</li>
      <li>Aufstallungsform</li>
      <li>weiteren gebäudespezifischen Merkmalen</li>
    </ul>

    <p>
      Auch hier gibt die Zahl in Klammern die Anzahl der verfügbaren Modelle an.
    </p>

    <h3 id="1-2-vorschaubilder-nutzen">
      1.2 Vorschaubilder nutzen
    </h3>

    <p>
      Die Vorschaubilder der Grundrisse unterstützen die Auswahl geeigneter Modelle.
    </p>

    <p>
      Durch Anklicken der Vorschaubilder wird in einem neuen Fenster eine
      vergrößerte Darstellung in einer höheren Auflösung geöffnet.
    </p>

    <h3 id="1-3-gebaeudekennung">
      1.3 Gebäudekennung
    </h3>

    <p>
      Jedes Modell besitzt eine eindeutige Kennung.
    </p>

    <p>
      Diese besteht aus:
    </p>

    <ul>
      <li>
        einem Kürzel für Tierkategorie oder Anlagenart
        (z. B. „MS“ für Mastschwein) und
      </li>
      <li>einer laufenden Nummer.</li>
    </ul>

    <h3 id="1-4-modelle-zum-vergleich-hinzufuegen">
      1.4 Modelle zum Vergleich hinzufügen
    </h3>

    <p>
      Aktivieren Sie die Checkbox in der Spalte <strong>„Hinzufügen“</strong>,
      um ein oder mehrere Modelle auszuwählen.
    </p>

    <p>
      Mit dem Button <strong>„Zum Vergleich“</strong> wechseln Sie zur
      Vergleichsansicht, in der die ausgewählten Modelle angezeigt werden.
    </p>

    <h3 id="1-5-schnellnavigation">
      1.5 Schnellnavigation
    </h3>

    <p>
      Die blauen Schaltflächen am rechten unteren Bildschirmrand ermöglichen
      Folgendes:
    </p>

    <ul>
      <li>Sprung zum Seitenanfang</li>
      <li>Sprung zum Seitenende</li>
      <li>Wechsel zur Vergleichsseite</li>
    </ul>


    <h2 id="2-modelle-vergleichen">
      2. Modelle vergleichen
    </h2>

    <p>
      In der Vergleichsansicht werden die ausgewählten Gebäude einander
      gegenübergestellt.
    </p>

    <h3 id="2-1-verfuegbare-informationen">
      2.1 Verfügbare Informationen
    </h3>

    <p>
      Für jedes Modell stehen zur Verfügung:
    </p>

    <ul>
      <li>Vorschau des Gebäudes</li>
      <li>PDF-Pläne</li>
      <li>Gebäudebeschreibungen</li>
      <li>Tierplatzzahlen</li>
      <li>Flächen- und Volumenangaben</li>
      <li>Investitionsbedarf</li>
      <li>Kostenblöcke</li>
      <li>DIN-276-Kostengruppen</li>
      <li>jährliche Gebäudekosten</li>
    </ul>

    <h3 id="2-2-diagramme">
      2.2 Diagramme
    </h3>

    <p>
      Diagramme zu den einzelnen Modellen veranschaulichen:
    </p>

    <ul>
      <li>Investitionsbedarf</li>
      <li>Flächen</li>
      <li>jährliche Gebäudekosten</li>
    </ul>

    <p>
      Die Darstellung einzelner Kostenkennwerte in den Diagrammen kann durch
      Anklicken des jeweiligen Farbfeldes in der Legende ein- und ausgeblendet
      werden.
    </p>

    <h3 id="2-3-anzeige-einschraenken">
      2.3 Anzeige einschränken
    </h3>

    <p>
      Über den Bereich <strong>„Anzeigen“</strong> können Modelle vorübergehend
      ausgeblendet und später wieder eingeblendet werden.
    </p>


    <h2 id="3-einstellungen-anpassen">
      3. Einstellungen anpassen
    </h2>

    <p>
      Unter dem Reiter <strong>„Einstellungen“</strong> können Sie die Darstellung
      der ausgewiesenen Kosten an Ihre Wünsche anpassen.
    </p>

    <h3 id="3-1-preisstand-aendern">
      3.1 Preisstand ändern
    </h3>

    <p>
      Mithilfe des Drop-Down-Menüs können Sie die Kosten auf den
      <strong>Preisstand eines früheren Jahres</strong> umrechnen.
    </p>

    <h3 id="3-2-preisfaktor-verwenden">
      3.2 Preisfaktor verwenden
    </h3>

    <p>
      Mit einem <strong>Preisfaktor</strong> können Sie:
    </p>

    <ul>
      <li>regionale Preisunterschiede berücksichtigen,</li>
      <li>zukünftige Preisentwicklungen abschätzen und</li>
      <li>die Umsatzsteuer einrechnen.</li>
    </ul>

    <h3 id="3-3-kostengruppen-auswaehlen">
      3.3 Kostengruppen auswählen
    </h3>

    <p>
      Über die Liste <strong>„Kostengliederung nach DIN 276“</strong> können
      einzelne Kostengruppen ein- oder ausgeblendet werden.
    </p>


    <h2 id="4-ergebnisse-exportieren">
      4. Ergebnisse exportieren
    </h2>

    <p>
      Die Gebäudepläne können als PDF und die Vergleichsergebnisse in einer Excel
      ausgegeben werden.
    </p>

    <p>
      Der Export erfolgt über die entsprechenden PDF-Download-Symbole bzw. die
      Export-Schaltflächen.
    </p>



  </article>
</div>




<div class="ktbl-spacer-top-bottom"></div>



<div class="ktbl-floating-container-ohne-rand-wrapper">
  <div class="ktbl-floating-content">
    <button (click)="onClickUp()" class="ktbl-button-primaer ktbl-button-icon-l" mat-raised-button="" type="button">
      <i class="fas fa-chevron-up ktbl-icon-vertical-align">
      </i>
    </button>
    <button (click)="onClickDown()" class="ktbl-button-primaer ktbl-button-icon-l" mat-raised-button="" type="button">
      <i class="fas fa-chevron-down ktbl-icon-vertical-align">
      </i>
    </button>
  </div>
</div>